<template>
  <div class="el-col-24">
    <h5 class="warp-title">留言设置</h5>
    <el-form ref="addFormRef" :model="addForm" label-width="120px" label-position="top" class="message-set my-form-style" :rules="addFormRules">
      <el-form-item label="留言开关:" class="oneline-item" prop="switchs">
        <el-switch v-model="addForm.switchs" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="2" style="margin-left: 10px"></el-switch>
      </el-form-item>
      <el-form-item label="留言时间段:" prop="pattern">
        <el-radio-group v-model="addForm.pattern" class="time-radio-wrapper">
          <el-radio :label="1">
            按时段开放
            <el-time-picker class="ml10" size="mini" v-model="addForm.startTime" placeholder="任意时间点" value-format="HH:mm" format="HH:mm"></el-time-picker>
            ~
            <el-time-picker size="mini" v-model="addForm.endTime" placeholder="任意时间点" value-format="HH:mm" format="HH:mm"></el-time-picker>
              <span class="time-tips">设置为按时段开放，在该时间段内，无论有无客服在线，用户均以留言方式提交咨询信息</span>
            </el-radio>
          <el-radio :label="2">全时段开放<span class="time-tips">设置为全时段开放，只要客服状态为挂起、离线（退出）则用户均以留言方式提交咨询信息。</span></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-button type="primary" style="margin-top: 30px;margin-left: 30px" :loading="isSubmitLoading" @click="onSubmit">保存</el-button>
    </el-form>
  </div>
</template>

<script>
import {imNoteSet, queryImNoteSet} from '../../api/message/index'
export default {
  name: 'MessageSet',
  created () {
    this.queryImNoteSet()
  },
  data () {
    return {
      isSubmitLoading: false,
      addFormRules: {
        switchs: [{required: true, message: '请选择留言开关', trigger: 'blur'}],
        pattern: [
          {required: true, message: '请选择留言时间段', trigger: ['blur', 'change']},
          {
            validator: (rule, value, callback) => {
              if (this.addForm.pattern === 1 && (!this.addForm.startTime || !this.addForm.endTime)) {
                callback(new Error('请选择留言时间段'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      addForm: {
        switchs: 2,
        pattern: 0,
        startTime: '',
        endTime: ''
      }
    }
  },
  methods: {
    queryImNoteSet () {
      queryImNoteSet().then(res => {
        if (res.data.resultCode === 0) {
          this.addForm = res.data.resultData
        } else {
          this.$message(res.data.resultMessage)
        }
      })
    },
    onSubmit () {
      this.$refs.addFormRef.validate(res => {
        if (res) {
          this.isSubmitLoading = true
          imNoteSet(this.addForm).then(res => {
            this.isSubmitLoading = false
            if (res.data.resultCode === 0) {
              this.$message.success('设置成功')
              this.queryImNoteSet()
            } else {
              this.$message(res.data.resultMessage)
            }
          }).finally(() => {
            this.isSubmitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.message-set{
  .oneline-item{
    display: flex;
  }
  .time-radio-wrapper{
    padding-left: 30px;
    padding-top: 10px;
    label.el-radio{
      display: block;
      margin-bottom: 20px;
    }
    .time-tips{
      font-size: 12px;
      color: #909399;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Message/Set.vue